"use client";

import { Button } from "@/components/ui/button";
import { LoaderCircle, LogOut } from "lucide-react";
import Image from "next/image";

interface PaywallBookDemoScreenProps {
  onBookDemo: () => void;
  onLogout?: () => void;
  isLogoutPending?: boolean;
}

export const PaywallBookDemoScreen = ({
  onBookDemo,
  onLogout,
  isLogoutPending = false,
}: PaywallBookDemoScreenProps) => {
  return (
    <div className="relative h-full w-full overflow-hidden rounded-[20px] bg-[#f5f5f6] text-center">
      <Image
        src="/images/onboarding/book-demo.png"
        alt=""
        width={899}
        height={292}
        priority
        className="pointer-events-none absolute bottom-[-5px] left-[-20px] z-0 h-[292px] w-[899px] max-w-none select-none object-fill opacity-80"
      />

      <div className="absolute left-3 right-3 top-5 z-20 flex h-8 items-center justify-end gap-2.5 px-3 py-2.5">
        {onLogout && (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-3.5 w-3.5 rounded-sm p-0 text-[#85878b] hover:bg-black/[0.04] hover:text-[#3b3b3e]"
            onClick={onLogout}
            disabled={isLogoutPending}
            aria-label="Log out"
          >
            {isLogoutPending ? (
              <LoaderCircle className="h-3.5 w-3.5 animate-spin" />
            ) : (
              <LogOut className="h-3.5 w-3.5" />
            )}
          </Button>
        )}
      </div>

      <div className="absolute left-3 top-[68px] z-10 h-[460px] w-[808px]">
        <div className="absolute left-[143px] top-[79px] h-[263px] w-[521px]">
          <div className="absolute left-0 top-0 flex w-[521px] flex-col items-center gap-8 leading-none [word-break:break-word]">
            <div className="flex w-[374px] flex-col items-center gap-[12px]">
              <h2 className="h-[38px] w-full font-['Plantin_MT_Pro',Plantin,Georgia,serif] text-[42px] font-light italic leading-[38px] tracking-[-0.21px] text-[#ff512a]">
                Book a Demo
              </h2>
              <p className="w-full whitespace-nowrap font-['Plantin_MT_Pro',Plantin,Georgia,serif] text-[20px] leading-5 tracking-[-0.1px] text-[#0f0510]">
                Your agentic commerce journey starts here.
              </p>
            </div>

            <p className="w-[521px] font-['Aspekta',Arial,sans-serif] text-sm leading-5 text-[#85878b]">
              <span className="block">
                Jurni generates and orchestrates shopping journeys across Meta,
                creators, search,
              </span>
              <span className="block">
                and AI agents, so every shopper lands on the experience most
                likely to convert.
              </span>
              <span className="block">
                Talk to our team to see how leading brands lift CVR, ROAS, and
                AOV.
              </span>
            </p>
          </div>

          <Button
            type="button"
            className="absolute left-1/2 top-[227px] h-9 w-[222px] -translate-x-1/2 rounded-md border border-white/[0.12] px-3 text-sm font-medium text-white shadow-[0px_1px_2px_0px_rgba(27,28,29,0.48),0px_0px_0px_1px_#1b1c1e]"
            onClick={onBookDemo}
          >
            Book a Demo
          </Button>
        </div>
      </div>
    </div>
  );
};
